import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

const TrItem = ({ name, value, className }) => {
  return (
    <tr style={{ borderColor: 'transparent' }}>
      <td className="fw-semibold pb-0">{name} </td>
      <td className={` pb-0 ${className}`}>{value || '---'}</td>
    </tr>
  );
};

const AssetCustomFields = ({ data }) => {
  const activeCustomFields = data.customFields || [];

  const [showBody, setShowBody] = useState(true);

  const getValueByType = (customFieldValue) => {
    if (!customFieldValue) return '---';

    if (customFieldValue.stringValue !== undefined) return customFieldValue.stringValue;
    if (customFieldValue.intValue !== undefined) return customFieldValue.intValue;
    if (customFieldValue.decimalValue !== undefined) return customFieldValue.decimalValue;
    if (customFieldValue.textValue) return customFieldValue.textValue;
    if (customFieldValue.boolValue !== undefined) return customFieldValue.boolValue ? 'Sim' : 'Não';
    if (customFieldValue.datetimeValue) return new Date(customFieldValue.datetimeValue).toLocaleString();
    if (customFieldValue.dropdownOption) return customFieldValue.dropdownOption.label;

    return '---';
  };


  return (
    <Card className="w-100">
      <Flex
        className="w-100 p-3 bg-100 rounded-top-4"
        onClick={() => setShowBody(!showBody)}
        role="button"
        justifyContent="between"
      >
        <h6 className="m-0">CAMPOS PERSONALIZADOS</h6>
        <FontAwesomeIcon icon={showBody ? faChevronUp : faChevronDown} size="sm" />
      </Flex>
      {showBody && (
        <Card.Body className='w-100'>
          <Row>
            {activeCustomFields.length > 0 ? (
              activeCustomFields.map((field) => (
                <Col md={4} key={field.id}>
                  <td
                    style={{ width: '33%' }}
                    className={`pb-0`}>
                    <strong>{field.name}</strong>: {getValueByType(field.customFieldValue) || '---'}
                  </td>
                </Col>
              ))
            ) : (
              <TrItem name="Nenhum campo personalizado encontrado" value="---" />
            )}
          </Row>
        </Card.Body>
      )}
    </Card>
  );
};

export default AssetCustomFields;
